module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/common/arrow_down_sp-57405066fe6751eb1f631063c2f52b7c.svg";